module.exports = __webpack_public_path__ + "static/media/backarrow.abc95dae.svg";